<template>
    <div class="article-privates-contact">
        <p>
            Lauren tailors all private sessions to the needs of the individual. Whether that's at an event, online or
            through video review.
        </p>
        <p>To book a one-to-one-session, please get in touch today!</p>
    </div>
</template>

<script>
export default {
    name: 'ArticlePrivatesContact',
};
</script>
